import React, { useState } from "react";

const WaterRipple = () => {
  const [ripples, setRipples] = useState<
    { id: number; x: number; y: number }[]
  >([]);

  return (
    <div
      className="relative h-96 bg-gradient-to-b from-blue-200 to-blue-300 rounded-2xl"
      onClick={(e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setRipples((prev) => [
          ...prev,
          {
            id: Date.now(),
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
          },
        ]);
      }}
    >
      {ripples.map((r) => (
        <span
          key={r.id}
          className="absolute w-16 h-16 border-2 border-blue-500/50 rounded-full animate-ping"
          style={{ left: r.x - 32, top: r.y - 32 }}
        />
      ))}
    </div>
  );
};

export default WaterRipple;